const locale = {
  // Options
  items_per_page: '/ पृष्ठ',
  jump_to: 'यावर जा ',
  jump_to_confirm: 'पुष्टी करा',
  page: 'पृष्ठ',
  // Pagination
  prev_page: 'मागील पृष्ठ',
  next_page: 'पुढील पृष्ठ',
  prev_5: 'मागील ५ पृष्ठे',
  next_5: 'पुढील ५ पृष्ठे',
  prev_3: 'मागील ३ पृष्ठे',
  next_3: 'पुढील ३ पृष्ठे',
  page_size: 'पृष्ठ आकार'
};
export default locale;